import { registerVueComponentAndAngularBindings } from '/vodalys/vvuejs'

import VrunFormBuilder from './VrunFormBuilder.vue'

registerVueComponentAndAngularBindings('vrun_form:builder', 'vrunFormBuilder', VrunFormBuilder)
